// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.small-rating {\n  text-align: center;\n}\n.small-rating > i {\n  padding: 0 !important;\n}\n.route-tab {\n  background-color: #0031e2;\n}\n.route-tab span {\n  padding: 5px;\n  color: white;\n  font-weight: bold;\n}\n.route-tab-slider {\n  background-color: #44d3af !important;\n  border-color: #44d3af !important;\n  height: 7px;\n}\n", ""]);
// Exports
module.exports = exports;
